import * as $ from 'jquery';
import 'bootstrap';
import { memberPortal } from "../member-portal";
import { adobeDataLayerWrapper } from "../adobeDataLayerMethod";
import * as moment from 'moment';

export class memberMyActivity {

	private memberBase: any = new memberPortal();
	private stmForm: any = $('#members-activities-statement-form--lcp');
	
	initTables(): any {
		createActivityDropdown();
		callAjax(1,"all");
		$("#members-activity-period-select").change(function() {
			callAjax(1,$('option:selected', this).val());
		});
		handleTitle();
	
	}
	loadURLData():any{
		let hashValue = window.location.hash;
		let activeTab = hashValue.substring(1);
		$(`h2.${activeTab}-title`).removeClass("hidden")
		$(`.${activeTab}-desc`).removeClass("hidden")
		$("#members_activity_conetnt").children("h2").not(`.${activeTab}-title`).addClass("hidden")
		$("#members_activity_conetnt").children(".description").not(`.${activeTab}-desc`).addClass("hidden")
		if (activeTab == 'transaction') {
			$("#transaction").addClass("in active");
			$("#retro-claim").removeClass("in active");
			$("#spend_benefits").removeClass("in active");
			$("#transaction--li").addClass("active");
			$("#retro-claim--li").removeClass("active");
			$("#spend_benefits--li").removeClass("active");
		} else if (activeTab == 'retro-claim') {
			$("#transaction").removeClass("in active");
			$("#retro-claim").addClass("in active");
			$("#spend_benefits").removeClass("in active");
			$("#transaction--li").removeClass("active");
			$("#retro-claim--li").addClass("active");
			$("#spend_benefits--li").removeClass("active");
		}else if(activeTab == 'spend_benefits'){
			$("#transaction").removeClass("in active");
			$("#retro-claim").removeClass("in active");
			$("#spend_benefits").addClass("in active");
			$("#transaction--li").removeClass("active");
			$("#retro-claim--li").removeClass("active");
			$("#spend_benefits--li").addClass("active");
		}

	}
}

function createActivityDropdown(){
	const currentDate = new Date();
	var selCat =$("#members-activity-period-select").selectize();
	const currentYear = currentDate.getFullYear();
	for (var i=0; i<4; i++) {
		//const currentMonthYear = currentDate.toLocaleString('default', { month: 'long' }) + " " + currentDate.getFullYear();
		//var monthVal = ((currentDate.getMonth()+1) > 9 ) ? (currentDate.getMonth()+1) : ("0" + (currentDate.getMonth()+1)) ;
		//var valueOfDrop = currentDate.getFullYear()+"-"+monthVal+"-01";
		//currentDate.setMonth(currentDate.getMonth()-1);
		//selCat[0].selectize.addOption({value:valueOfDrop,text:currentMonthYear});
		currentYear = "In " + currentDate.getFullYear();
		// var monthVal = ((currentDate.getMonth()+1) > 9 ) ? (currentDate.getMonth()+1) : ("0" + (currentDate.getMonth()+1)) ;
		var valueOfDrop = currentDate.getFullYear();
		currentDate.setYear((currentDate.getFullYear()-1));
		selCat[0].selectize.addOption({value:valueOfDrop,text:currentYear});
	}
	selCat[0].selectize.setValue('all');
	
}

function callAjax(currentPageNumber: number, dropdownVal :any) { 
	$("#transaction").addClass("disable_html");
	if(location.host == "localhost:5000"){
		var data_obj = "pageOffset=" + currentPageNumber + "&date=" + dropdownVal;
		$.ajax({
			type: 'GET',
			url: 'http://localhost:5000/dummy-data/activities.JSON',
			data: data_obj,
			contentType: 'application/json',
			success: function (data: any) {
				$("#transaction").removeClass("disable_html");
				createTable(data.jsonDataArray);
				createPagination(currentPageNumber, data.numberOfPages);
			},
			error: function (error: any) {
			}
		});

	}else{ 
		var data_obj = "pageOffset=" + currentPageNumber + "&date=" + dropdownVal;
		$.ajax({
			type: 'GET',
			url: '/bin/services/new/getActivityDetailsLCP',
			data: data_obj,
			contentType: 'application/json',
			success: function (data: any) {
				$("#transaction").removeClass("disable_html");
				$("#claim-submission-status").addClass("disable_html");
				createTable(data.jsonDataArray);
				createPagination(currentPageNumber, data.numberOfPages);
			},
			error: function (error: any) {
			}
		});

	}
	
}

function undefinedCheck(varVal: any) {
	if (typeof varVal === "undefined") {
		return "";
	}
	else {
		return varVal;
	}
}

function createPagination(currentPage:any,numberOfPages:any){

			 if(currentPage < 10 && numberOfPages >= 10)
			 {
				paginationHTML(currentPage,1,10,numberOfPages);
			 }else
			 if(currentPage <= 10 && numberOfPages <= 10)
			 {
				paginationHTML(currentPage,1,numberOfPages,numberOfPages);
			 }else
			 if(currentPage >= 10 && numberOfPages <= (parseInt(currentPage)+5)){
				paginationHTML(currentPage, (parseInt(numberOfPages)-10),numberOfPages, numberOfPages);
			 }else
			 if(currentPage >= 10 && numberOfPages >= (parseInt(currentPage)+5)){
				paginationHTML(currentPage, (parseInt(currentPage)-5),currentPage+5, numberOfPages);
			 }
	 }


function createTable(jsonDataArrayStr: any) {

	var jsonDataArray = JSON.parse(jsonDataArrayStr);
	jsonDataArray = jsonDataArray.map(data => {data.activity_date = moment(data.activity_date, 'DD-MM-YYYY').format('YYYY-MM-DD'); return data})
		let benefitsTable = $('#DataTables_Table_DatasetNew');
		benefitsTable.dataTable().fnClearTable();
		benefitsTable.dataTable().fnDestroy();

		let dataSet = jsonDataArray;
		let tableOptions = {
			data: dataSet,
			"paging":   false,
			// "ordering": false,
			"responsive": false,
			"info":     false,
			"columns": [
				{ "data": "activity_date" ,
				   "render" : function(data,type,row){
					if(type === "sort" || type === "type"){
						return data;
					}
					return moment(data, 'YYYY-MM-DD').format('DD-MM-YYYY');
				   }
				},
				{ "data": "description" },
				{ "data": "benefits" },
				{ "data": "award_points" },
				{ "data": "tier_points" }
			],
			"columnDefs": [
			  { "width": "300px", "targets": 1},
			]

		  }
		let benefitsDataTable:any = benefitsTable.dataTable(tableOptions);
		
}

function paginationHTML(currentPage: any, startPage: any, lastPage: any, numberOfPages:any) {
	var paginationHTML = "";
	if(currentPage == 1){
		paginationHTML += '<a class="paginate_button previous disabled" aria-controls="DataTables_Table_0"  data-dt-idx="' +  (parseInt(currentPage)) + '" id="DataTables_Table_0_next">Previous</a><span>';
	}else{
		paginationHTML += '<a class="paginate_button previous" aria-controls="DataTables_Table_0" data-dt-idx="' +  (parseInt(currentPage)- 1) + '" tabindex="0" id="DataTables_Table_0_next">Previous</a><span>';
	}
	for (var i = startPage; i <= lastPage; i++) {
		if (i == currentPage) {
			paginationHTML += '<a class="paginate_button current" aria-controls="DataTables_Table_0"  data-dt-idx="' + i + '" tabindex="0"> ' + i + '</a>';
		} else {
			paginationHTML += '<a class="paginate_button" aria-controls="DataTables_Table_0"  data-dt-idx="' + i + '" tabindex="0"> ' + i + '</a>';
		}
	}
	if(numberOfPages == currentPage){
		paginationHTML += '</span><a class="paginate_button next disabled" aria-controls="DataTables_Table_0" data-dt-idx="' + (parseInt(currentPage)) + '" tabindex="0" id="DataTables_Table_0_next">Next</a>';
	}
	else{
		paginationHTML += '</span><a class="paginate_button next" aria-controls="DataTables_Table_0" data-dt-idx="' + (parseInt(currentPage) + 1) + '" tabindex="0" id="DataTables_Table_0_next">Next</a>';
	}
	
	$("#DataTables_Table_0_paginate").html(paginationHTML);

	$(".paginate_button").on("click", function(){
		callAjax($(this).data("dt-idx"),$("#members-activity-period-select").val());
	});

}

// let benefitsDataTable:any = benefitsTable.dataTable(tableOptions);


function myFunction(id:any){
	callAjax(id);
}

function handleTitle() {
$("#members_activity ul li a").click(function(){
	let activeTab  = $(this).attr("href").slice(1);
	// AA tracking click event
	let aTab = null;
	if (activeTab == 'transaction') {
		aTab = 'transactions';
	} else if (activeTab == 'retro-claim') {
		aTab = 'claim-missing-points';
	}
	adobeDataLayer.push('click', {
		'pageName': 'mas:my:en:enrich-portal:home:activity',
		'pageType': 'Enrich Activity Page',
		'clickName': 'click:tab-click:'+aTab,
		'componentType': 'tab',
		'componentName': 'Member Activity tab',
		'componentID': aTab,
		'attributes': []
	});
	// AA tracking End
	$(`h2.${activeTab}-title`).removeClass("hidden")
	$(`.${activeTab}-desc`).removeClass("hidden")
	$("#members_activity_conetnt").children("h2").not(`.${activeTab}-title`).addClass("hidden")
	$("#members_activity_conetnt").children(".description").not(`.${activeTab}-desc`).addClass("hidden")

});
// handle sub title for tracking event
let btnArr = {
	'Malaysia Airlines': 'malaysia-airlines',
	'Other Airlines': 'other-airlines',
	'Non Airlines': 'non-airlines',
	'Submission Status': 'submission-status'
}
let attributes = [];
$('.miles-claim-missing .nav-tabs li a').click(function () {
	let btn = $(this).html()
	adobeDataLayer.push('click', {
		'pageName': 'mas:my:en:enrich-portal:home:activity',
		'pageType': 'Enrich Activity Page',
		'clickName': 'click:tab-click:'+btnArr[btn],
		'componentType': 'tab',
		'componentName': 'Claim Missing Points tab',
		'componentID': 'Claim Missing Points tab - '+btnArr[btn],
		'attributes': []
	});
});
}

let scope: Element = document.querySelector('#members_activity_conetnt');

if (scope) {
	try {
		var adobeDataLayer = new adobeDataLayerWrapper();
		adobeDataLayer.push('pageLoaded', {
			'pageName': 'mas:my:en:enrich-portal:home:activity',
			'pageType': 'Enrich Activity Page',
			'attributes': []
		});
		let membermyactivity = new memberMyActivity();
		membermyactivity.initTables();
		membermyactivity.loadURLData();
		
	} catch (e) {  /*console.error(e); */ }
	
}
